/* eslint key-spacing: 'off', comma-spacing: 'off' */
//import CtColumn from '@/bo/CtColumn';

export default function CtColumn (id, title, totalSourceRecords, isRowTotal) {
    this.id = id;
    this.title = title;
    this.totalSourceRecords = totalSourceRecords;
    this.isRowTotal = isRowTotal;
    // this.id = id === undefined ? null : id;
    // this.title = title === undefined ? null : title;
    // this.variables = variables === undefined || variables === null ? [] : variables;
    // this.years = years === undefined ? null : years;
  }
//   CtColumn.copy = function (group) {
//     return new CtColumn(group.id, group.title, group.variables, group.years);
//   };
  
//   CtColumn.createFromCtColumn = function (g) {
//     return new CtColumn(g.id, g.title, g.variables, g.years);
//   };
  //CtColumn.nullGroup = function () {
  //  return {}
  //  return new VariableSelection(new VariableObject('location', 'Location'),
  //    'location', new CtColumn(), /*include=*/true);
  //};
  